import {
  type TCategoryDictionaryApi,
  type TCategoryDictionaryDto
} from '@/components/AdminPanel/Directory/types/categories.types';
import {
  type TReasonDictionaryApi,
  type TReasonDictionaryDto
} from '@/components/AdminPanel/Directory/types/reasons.types';
import {
  type TTemplateDictionaryApi,
  type TTemplateDictionaryDto
} from '@/components/AdminPanel/Directory/types/templates.types';

import { ApiConnector } from '../api.connector';

class DictionaryApi extends ApiConnector {
  // ------- Categories -------
  public getDictCategories(params: {
    limit: number;
    page: number;
    isActive?: boolean;
    searchTerm?: string;
  }): Promise<{
    total: number;
    category: TCategoryDictionaryApi[];
  }> {
    return this.call({
      path: 'admin/dictionaries/support_categories',
      params,
      cancelable: true
    });
  }

  public getDictCategoryById(
    categoryId: string
  ): Promise<TCategoryDictionaryApi> {
    return this.call({
      path: `admin/dictionaries/support_categories/${categoryId}`,
      cancelable: true
    });
  }

  public createDictCategory(body: TCategoryDictionaryDto) {
    return this.call({
      path: `admin/dictionaries/support_categories`,
      method: 'post',
      body
    });
  }

  public updateDictCategory(body: TCategoryDictionaryDto) {
    return this.call({
      path: `admin/dictionaries/support_categories/${body.uuid}`,
      method: 'patch',
      body
    });
  }

  // ------- Reasons -------
  public getDictReasons(
    limit?: number,
    page?: number,
    searchTerm?: string
  ): Promise<{
    total: number;
    reason: TReasonDictionaryApi[];
  }> {
    return this.call({
      path: 'admin/dictionaries/support_reasons',
      params: {
        limit,
        page,
        searchTerm
      },
      cancelable: true
    });
  }

  public getDictReasonById(reasonId: string): Promise<TReasonDictionaryApi> {
    return this.call({
      path: `admin/dictionaries/support_reasons/${reasonId}`,
      cancelable: true
    });
  }

  public createDictReason(body: TReasonDictionaryDto) {
    return this.call({
      path: `admin/dictionaries/support_reasons`,
      method: 'post',
      body
    });
  }

  public updateDictReason(body: TReasonDictionaryDto) {
    return this.call({
      path: `admin/dictionaries/support_reasons/${body.uuid}`,
      method: 'patch',
      body
    });
  }

  // ------- Templates -------
  public getDictTemplates(
    limit?: number,
    page?: number,
    searchTerm?: string
  ): Promise<{
    total: number;
    template: TTemplateDictionaryApi[];
  }> {
    return this.call({
      path: 'admin/dictionaries/support_templates',
      params: {
        limit,
        page,
        searchTerm
      },
      cancelable: true
    });
  }

  public getDictTemplateById(
    templateId: string
  ): Promise<TTemplateDictionaryApi> {
    return this.call({
      path: `admin/dictionaries/support_templates/${templateId}`,
      cancelable: true
    });
  }

  public createDictTemplate(body: TTemplateDictionaryDto) {
    return this.call({
      path: `admin/dictionaries/support_templates`,
      method: 'post',
      body
    });
  }

  public updateDictTemplate(body: TTemplateDictionaryDto) {
    return this.call({
      path: `admin/dictionaries/support_templates/${body.uuid}`,
      method: 'patch',
      body
    });
  }
}

export const dictionaryApi = new DictionaryApi();
